<template>
  <div>
    <div class="mergeLeadRow">
      <div class="mergeLeadRow--heading">
        <p>Primary Number</p>
      </div>

      <div class="mergeLeadRow--value mergeLeadRow--value-select">
        <b-select
          v-model="selected"
          size="is-small"
          expanded
          @input="handleChange"
        >
          <option
            v-for="(phoneNumber, index) in phoneNumbers"
            :value="phoneNumber.value"
            :key="index"
          >{{ phoneNumber.value }}</option>
        </b-select>
      </div>
    </div>

    <p v-show="checkboxNumbers.length > 10" class="py-100 text-center has-text-danger">You can only select up to 10 phone numbers</p>

    <div class="mergeLeadRow"
      v-for="(phoneField, index) in phoneFields"
      :key="index"
      v-if="showRow(phoneField)"
    >
      <div class="mergeLeadRow--heading">
        <p v-if="index === 0">Phone Numbers</p>
      </div>

      <div class="mergeLeadRow--value">
        <template v-if="getCurrentPhone(phoneField)">
          <b-checkbox
            v-model="checkboxNumbers"
            :native-value="getCurrentPhone(phoneField).value"
            class="mr-0"
            :disabled="selected === getCurrentPhone(phoneField).value"
          >
            <span>{{ getCurrentPhone(phoneField).value }}</span>
          </b-checkbox>
        </template>
        <template v-else>
          <span>--</span>
        </template>
      </div>

      <div class="mergeLeadRow--value">
        <template v-if="getDuplicatePhone(phoneField)">
          <b-checkbox
            v-model="checkboxNumbers"
            :native-value="getDuplicatePhone(phoneField).value"
            class="mr-0"
            :disabled="selected === getDuplicatePhone(phoneField).value"
          >
            <span>{{ getDuplicatePhone(phoneField).value }}</span>
          </b-checkbox>
        </template>
        <template v-else>
          <span>--</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "MergeContactPhones",
  props: {
    currentValue: {
      type: String | Number | null,
      required: true,
    },
    currentPhones: {
      type: Array,
      default: () => []
    },
    duplicatePhones: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      phoneFields: [
        'phone_1',
        'phone_2',
        'phone_3',
        'phone_4',
        'phone_5',
        'phone_6',
        'phone_7',
        'phone_8',
        'phone_9',
        'phone_10'
      ],
      selected: this.currentValue,
      checkboxNumbers: [],
    }
  },
  mounted() {
    this.checkboxNumbers = [
      ...this.currentPhones.map(phone => phone.value),
      ...this.duplicatePhones.map(phone => phone.value)
    ]
  },
  computed: {
    phoneNumbers() {
      return [
        ...this.currentPhones,
        ...this.duplicatePhones
      ]
    },
  },
  methods: {
    handleChange() {
      if (this.checkboxNumbers.includes(this.selected)) return

      this.checkboxNumbers.push(this.selected)
    },
    getCurrentPhone(field) {
      return this.currentPhones.find(phone => phone.field === field)
    },
    getDuplicatePhone(field) {
      return this.duplicatePhones.find(phone => phone.field === field)
    },
    showRow(field) {
      return !!this.getCurrentPhone(field) || !!this.getDuplicatePhone(field)
    },
    isValid() {
      return this.checkboxNumbers.length <= 10
    },
    emitValues() {
      const fields = this.phoneFields.filter(field => field !== 'phone_1')
      const selectedNumbers = this.checkboxNumbers.filter(number => number !== this.selected)
      let phones = { phone_1: this.selected }

      fields.forEach((field, index) => {
        phones[field] = null

        if (selectedNumbers[index]) phones[field] = selectedNumbers[index]
      })

      return phones
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.mergeLeadRow {
  display: flex;
  justify-content: space-between;
  width: 100%;

  &:last-child {
    .mergeLeadRow--value {
      border-bottom: none;
    }
  }

  &--heading {
    width: 26%;
    font-size: 0.875rem;
    padding: 0.75rem 0;
  }

  &--checkboxes {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: calc(74% - 24px);

    &-value {
      width: calc(37% - 24px);
      padding: .75rem .25rem;
    }
  }

  &--value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(37% - 24px);
    padding: .75rem .25rem;
    border-bottom: 1px solid $border;

    &-select {
      width: calc(74% - 24px);

      .control {
        width: 100%;
      }
    }
  }
}
</style>
